import { IResidenceForm, IUpdateResidence } from '../../shared';
import { FamilySituation, LivingSituation } from '../enums';
import { getCountry } from '../../shared/utils/origins.util';

export const residenceFromFormMapper = (residence: IResidenceForm): IUpdateResidence => {
    return {
        ...residence,
        street: residence.street || '',
        number: residence.number || '',
        postalCode: residence.postalCode || '',
        city: residence.city || '',
        country: residence.country?.code || '',
        livingSituation: (residence?.livingSituation as LivingSituation) || null,
        familySituation: (residence?.familySituation as FamilySituation) || null,
    };
};

export const residenceToFormMapper = (data: IUpdateResidence): IResidenceForm => {
    return {
        ...data,
        livingSituation: data.livingSituation ? data.livingSituation : undefined,
        familySituation: data.familySituation ? data.familySituation : undefined,
        country: data.country ? getCountry(data.country) : { code: 'be', label: 'België' },
    };
};
